module.exports = __webpack_public_path__ + "img/turkcell-foursquare-launch-06.2a0cd6b7.jpg";